import * as i0 from '@angular/core';
import { EventEmitter, Injector, forwardRef, Component, ViewEncapsulation, Optional, Inject, Self, ViewChild, ContentChild, Output, Input, HostBinding, Directive, NgModule } from '@angular/core';
import * as i6 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i7 from '@angular/material/datepicker';
import { MatDatepickerModule } from '@angular/material/datepicker';
import * as i1 from '@angular/material/core';
import { MAT_DATE_FORMATS, DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import * as i5 from '@angular/forms';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i2 from '@ngx-translate/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatMomentDateModule, MomentDateAdapter } from '@angular/material-moment-adapter';
import { Subject, fromEvent } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TemplatePortal, DomPortalOutlet, ComponentPortal } from '@angular/cdk/portal';
import _rollupMoment from 'moment';
import { EuiTimepickerComponent, EuiTimepickerModule } from '@eui/components/eui-timepicker';
import * as i3 from '@eui/core';
import { DYNAMIC_COMPONENT_CONFIG } from '@eui/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { BaseDirective } from '@eui/components/shared';
import * as i4 from '@angular/cdk/overlay';
import * as i8 from '@eui/components/eui-button';
import { EuiButtonModule } from '@eui/components/eui-button';
import * as i9 from '@eui/components/eui-icon';
import { EuiIconModule } from '@eui/components/eui-icon';
import * as i10 from '@eui/components/eui-input-text';
import { EuiInputTextModule } from '@eui/components/eui-input-text';
import * as i11 from '@eui/components/eui-input-group';
import { EuiInputGroupModule } from '@eui/components/eui-input-group';

const moment = _rollupMoment || _rollupMoment;
class EuiDatepickerComponent extends BaseDirective {
    constructor(adapter, translateService, localeService, uxAppShellService, componentFactoryResolver, injector, appRef, cdkConnectedOverlay, viewContainerRef, euiLetterFormat, control, format) {
        super();
        this.adapter = adapter;
        this.translateService = translateService;
        this.localeService = localeService;
        this.uxAppShellService = uxAppShellService;
        this.componentFactoryResolver = componentFactoryResolver;
        this.injector = injector;
        this.appRef = appRef;
        this.cdkConnectedOverlay = cdkConnectedOverlay;
        this.viewContainerRef = viewContainerRef;
        this.euiLetterFormat = euiLetterFormat;
        this.control = control;
        this.inputFormControl = new FormControl();
        this.breakpointsValue = {
            isMobile: false,
            isTablet: false,
            isLtDesktop: false,
            isDesktop: false,
            isXL: false,
            isXXL: false,
        };
        this.inputChange = new EventEmitter();
        this.dateSelect = new EventEmitter();
        this.styleClass = '';
        this.togglerIconSvg = 'eui-calendar-outline';
        this.type = 'regular';
        /** @deprecated will be removed in eUI16 */
        this.e2eAttr = 'eui-datepicker';
        this.datepickerFilter = this.datepickerFiltering;
        this._isDatetimepicker = false;
        this._hasSeconds = false;
        this._isOneInputField = false;
        this._hasNoButton = false;
        this._isDatepickerBlock = false;
        this._isReadOnly = false;
        this._isDisabled = false;
        this._isInputDisabled = false;
        this._isButtonDisabled = false;
        this._isPickerDisabled = false;
        this._isClearable = false;
        this._hasActionButtons = false;
        this._hasTodayButton = false;
        this.destroy$ = new Subject();
        this.isNull = false;
        this.propagateChange = (_) => {
        };
        this.propagateTouched = () => {
        };
        this.format = format;
        if (this.control) {
            this.control.valueAccessor = this;
        }
    }
    get isDatetimepicker() { return this._isDatetimepicker; }
    set isDatetimepicker(value) { this._isDatetimepicker = coerceBooleanProperty(value); }
    get hasSeconds() { return this._hasSeconds; }
    set hasSeconds(value) { this._hasSeconds = coerceBooleanProperty(value); }
    get isOneInputField() { return this._isOneInputField; }
    set isOneInputField(value) { this._isOneInputField = coerceBooleanProperty(value); }
    get hasNoButton() { return this._hasNoButton; }
    set hasNoButton(value) { this._hasNoButton = coerceBooleanProperty(value); }
    get isDatepickerBlock() { return this._isDatepickerBlock; }
    set isDatepickerBlock(value) { this._isDatepickerBlock = coerceBooleanProperty(value); }
    get isReadOnly() { return this._isReadOnly; }
    set isReadOnly(value) { this._isReadOnly = coerceBooleanProperty(value); }
    get isDisabled() { return this._isDisabled; }
    set isDisabled(value) { this._isDisabled = coerceBooleanProperty(value); }
    get isInputDisabled() { return this._isInputDisabled; }
    set isInputDisabled(value) { this._isInputDisabled = coerceBooleanProperty(value); }
    get isButtonDisabled() { return this._isButtonDisabled; }
    set isButtonDisabled(value) { this._isButtonDisabled = coerceBooleanProperty(value); }
    get isPickerDisabled() { return this._isPickerDisabled; }
    set isPickerDisabled(value) { this._isPickerDisabled = coerceBooleanProperty(value); }
    get isClearable() { return this._isClearable; }
    set isClearable(value) { this._isClearable = coerceBooleanProperty(value); }
    /** @deprecated will be removed in eUI16 */
    get hasActionButtons() { return this._hasActionButtons; }
    set hasActionButtons(value) { this._hasActionButtons = coerceBooleanProperty(value); }
    /** @deprecated will be removed in eUI16 */
    get hasTodayButton() { return this._hasTodayButton; }
    set hasTodayButton(value) { this._hasTodayButton = coerceBooleanProperty(value); }
    get restrictToRegex() { return this._restrictToRegex; }
    set restrictToRegex(value) {
        try {
            if (value instanceof RegExp) {
                this._restrictToRegex = value;
            }
            else if (typeof value === 'string') {
                this._restrictToRegex = new RegExp(value);
            }
            else {
                throw new Error(`restrictToRegex can only be string or RegExp, it cannot be ${typeof value}`);
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    get cssClasses() {
        return [
            super.getCssClasses('eui-datepicker'),
        ].join(' ').trim();
    }
    ngOnInit() {
        this.inputFormControl.setValue(this.value);
        this.isInputDisabled ? this.inputFormControl.disable() : this.inputFormControl.enable();
        this.localeService.getState().pipe(takeUntil(this.destroy$)).subscribe(state => {
            this.adapter.setLocale(state.id);
        });
        if (!this.placeholder) {
            if (this.type === 'regular' && !this.isDatetimepicker) {
                this.translateService.stream('eui.datepicker.PLACEHOLDER').pipe(takeUntil(this.destroy$)).subscribe((result) => {
                    this.placeholder = result;
                });
            }
            else if (this.type === 'regular' && this.isDatetimepicker) {
                this.translateService.stream('eui.datepicker.ISDATETIMEPICKER')
                    .pipe(takeUntil(this.destroy$)).subscribe((result) => {
                    this.placeholder = result;
                });
            }
            else if (this.type === 'year') {
                this.translateService.stream('eui.datepicker.YEAR-PLACEHOLDER')
                    .pipe(takeUntil(this.destroy$)).subscribe((result) => {
                    this.placeholder = result;
                });
            }
            else if (this.type === 'month') {
                this.translateService.stream('eui.datepicker.MONTH-PLACEHOLDER')
                    .pipe(takeUntil(this.destroy$)).subscribe((result) => {
                    this.placeholder = result;
                });
            }
        }
        this.uxAppShellService.breakpoints$.pipe(takeUntil(this.destroy$)).subscribe(bkps => this.breakpointsValue = bkps);
    }
    ngAfterViewInit() {
        if (this.euiActionButtons) {
            this.templatePortal = new TemplatePortal(this.templatePortalRef, this.viewContainerRef);
        }
        if (this.isDatetimepicker || this.euiActionButtons) {
            this.calendar['closeCalendar'] = this.calendar.close;
            this.calendar.close = () => false;
        }
    }
    ngDoCheck() {
        if (this.control) {
            // marks the input control as touched/invalid if the form control is touched/invalid
            this.control?.touched ? this.inputFormControl.markAsTouched() : this.inputFormControl.markAsUntouched();
            this.control?.invalid ? this.inputFormControl.setErrors(this.control.errors) : this.inputFormControl.setErrors(null);
        }
    }
    ngOnChanges(changes) {
        if (changes && changes['isReadOnly']) {
            if (this.isReadOnly) {
                this.hasNoButton = true;
            }
            else {
                this.hasNoButton = false;
            }
        }
        if (changes && changes['isDisabled']) {
            this.setDisabledState(this.isDisabled);
        }
        if (changes && changes['value']) {
            this.inputFormControl.setValue(this.value);
        }
        else {
            if (this.dateOutputFormat && this.value) {
                this.propagateChange(moment(this.value).format(this.dateOutputFormat));
            }
        }
        if (changes && changes['isClearable']) {
            // when is clearable is used listen if onclear is fired and update the value
            if (this.isClearable) {
                this.inputChange.pipe(takeUntil(this.destroy$)).subscribe((event => {
                    if (event === null) {
                        this.value = event;
                        this.propagateChange(event);
                    }
                }));
            }
        }
    }
    createInjector(data) {
        const injectorTokens = [{ provide: DYNAMIC_COMPONENT_CONFIG, useValue: data }];
        return Injector.create({
            parent: this.injector,
            providers: injectorTokens
        });
    }
    openCalendar() {
        if (!this.isReadOnly) {
            this.calendar.open();
        }
        if (this.isDatetimepicker || this.euiActionButtons) {
            this.calendar.opened = true;
            // listens to the keydown event once the calendar opened
            const keydownListenerSubscription = fromEvent(document, 'keydown')
                .pipe(takeUntil(this.destroy$)).subscribe((event) => {
                switch (event.key) {
                    case 'Escape': //cloases the calendar on Escape
                        this.closeCalendar();
                        break;
                    case 'Enter': { //closes the calendar if pressing Enter on the close calendar button only
                        this.getEventPath(event).forEach((p) => {
                            if (p.className && p.className.indexOf('mat-datepicker-close-button') !== -1) {
                                this.closeCalendar();
                            }
                        });
                        break;
                    }
                }
            });
        }
        if (this.isDatetimepicker) {
            this.portalHost = new DomPortalOutlet(document.querySelector('mat-calendar'), this.componentFactoryResolver, // TODO: check again if there is an update on framework side EUI-6207
            this.appRef, this.injector);
            const timeConfig = {
                hours: this.value && moment(this.value).hours(),
                mins: this.value && moment(this.value).minutes(),
                secs: this.value && moment(this.value).seconds(),
                isDatetimepicker: this.isDatetimepicker,
                hasSeconds: this.hasSeconds,
                isOneInputField: this.isOneInputField,
                callbackFn: (hours, mins, secs) => {
                    if (this.euiActionButtons) {
                        this.value = moment();
                    }
                    this.value = typeof (this.value) === 'string' ? moment(this.value, moment.ISO_8601) : moment(this.value, this.format.parse.dateInput);
                    this.value.set({
                        hour: hours || 0,
                        minute: mins || 0,
                        second: secs || 0
                    });
                    if (!this.euiActionButtons) {
                        this.inputFormControl.setValue(this.value);
                        if (this.dateOutputFormat) {
                            this.propagateChange(moment(this.value).format(this.dateOutputFormat));
                        }
                        else {
                            this.propagateChange(moment(this.value));
                        }
                    }
                }
            };
            this.portal = new ComponentPortal(EuiTimepickerComponent, null, this.createInjector(timeConfig));
            const portalComponentInstance = this.portalHost.attach(this.portal);
        }
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.unsubscribe();
        this.portalHost?.detach();
    }
    /**
     * When calendar opens and isDatetimepicker or eui-action-buttons directive used, it closes the calendar when clicking outside of the overlay.
     * If eui-action-buttons directive is used it registers the template portal where the user can add projected content as a footer.
     */
    onOpened() {
        if (this.isDatetimepicker || this.euiActionButtons) {
            if (this.euiActionButtons) {
                this.calendar.registerActions(this.templatePortal);
            }
            this.cdkConnectedOverlay._attachedOverlays[0]._outsidePointerEvents.pipe(takeUntil(this.destroy$)).subscribe(() => {
                this.closeCalendar();
            });
        }
    }
    getEventPath(event) {
        if (event.path) {
            return event.path;
        }
        const path = [];
        let target = event.target;
        while (target.parentNode) {
            path.push(target);
            target = target.parentNode;
        }
        path.push(document, window);
        return path;
    }
    chosenDateHandler(normalizedDate, calendar) {
        if (this.dateOutputFormat) {
            const formattedValue = moment(normalizedDate, this.dateOutputFormat);
            this.value = formattedValue;
            this.inputFormControl.setValue(formattedValue);
            this.propagateChange(formattedValue.format(this.dateOutputFormat));
            this.inputChange.emit(formattedValue.format(this.dateOutputFormat));
            this.dateSelect.emit(formattedValue.format(this.dateOutputFormat));
        }
        else {
            this.value = normalizedDate;
            this.inputFormControl.setValue(this.value);
            this.propagateChange(this.value);
            this.dateSelect.emit(this.value ? this.value : null);
            this.inputChange.emit(this.value ? this.value : null);
        }
        calendar.close();
    }
    datepickerFiltering() {
        return true;
    }
    onDateInput(e) {
        if (!this.isDatetimepicker) {
            if (e.value === null) {
                this.propagateChange(null);
                this.inputChange.emit(null);
            }
            else if (this.dateOutputFormat) {
                this.value = moment(e.value, this.dateOutputFormat);
                this.propagateChange(this.value.format(this.dateOutputFormat));
                this.inputChange.emit(this.value.format(this.dateOutputFormat));
            }
            else {
                this.propagateChange(e.value);
                this.inputChange.emit(e?.value ? e.value : null);
            }
            this.propagateTouched();
        }
    }
    // TODO: check to combine onDateChange and onDateInput into one function ()
    onDateChange(e) {
        if (e.value === null) {
            this.propagateChange(null);
            this.dateSelect.emit(null);
            this.isNull = true;
        }
        else {
            this.isNull = false;
            if (this.isDatetimepicker) {
                const hours = this.value && moment(this.value).hours();
                const mins = this.value && moment(this.value).minutes();
                const secs = this.value && moment(this.value).seconds();
                this.value = moment(e.value, this.format.parse.dateInput);
                this.value.set({
                    hour: hours || 0,
                    minute: mins || 0,
                    second: secs || 0
                });
                if (this.calendar.opened) {
                    this.inputFormControl.setValue(this.value);
                }
                if (this.dateOutputFormat && this.value != null) {
                    this.propagateChange(moment(this.value).format(this.dateOutputFormat));
                }
                else {
                    this.propagateChange(moment(this.value));
                }
            }
            else {
                if (this.dateOutputFormat) {
                    this.value = moment(e.value, this.dateOutputFormat);
                    this.dateSelect.emit(this.value.format(this.dateOutputFormat));
                }
                else {
                    this.dateSelect.emit(e?.value ? e.value : null);
                }
            }
        }
    }
    changedInput(e) {
        const value = (typeof e === 'string') ? e : e.target.value;
        if (!this.isNull) {
            this.value = moment(value, this.format.parse.dateInput);
            this.inputFormControl.setValue(this.value);
            if (this.dateOutputFormat && this.value != null) {
                this.propagateChange(moment(this.value).format(this.dateOutputFormat));
            }
            else {
                this.propagateChange(moment(this.value));
            }
        }
    }
    onClear() {
        this.dateSelect.emit(null);
        this.inputChange.emit(null);
        this.propagateChange(null);
    }
    onKeypress(e) {
        if (e.key === 'Enter') {
            this.openCalendar();
            e.preventDefault();
        }
        if (this._restrictToRegex) {
            if (!this._restrictToRegex.test(e.key)) {
                e.preventDefault();
            }
        }
    }
    /**
     * Selects today's date
     */
    selectToday() {
        this.inputFormControl.setValue(moment());
    }
    /**
     * Closes the calendar when isDatetimepicker or eui-action-buttons used and removes the applied footer when eui-action-buttons used
     */
    closeCalendar() {
        this.calendar['closeCalendar']();
        if (this.euiActionButtons) {
            this.calendar.removeActions(this.templatePortal);
        }
    }
    /**
     * When eui-action-buttons used, it applies the date selection and closes the calendar
     */
    onDateSelectApply() {
        this.calendar._applyPendingSelection();
        this.closeCalendar();
    }
    writeValue(value) {
        this.value = value || '';
        this.inputFormControl.setValue(value);
    }
    registerOnChange(fn) {
        this.propagateChange = fn;
    }
    registerOnTouched(fn) {
        this.propagateTouched = fn;
    }
    convTypeToStartView(type) {
        switch (type) {
            case 'month':
                return 'year';
            case 'year':
                return 'multi-year';
            case 'regular':
                return 'month';
        }
    }
    setDisabledState(isDisabled) {
        this.isDisabled = isDisabled;
        if (isDisabled) {
            this.isInputDisabled = this.isPickerDisabled = this.isButtonDisabled = true;
        }
        else {
            this.isInputDisabled = this.isPickerDisabled = this.isButtonDisabled = false;
        }
        this.isInputDisabled ? this.inputFormControl.disable() : this.inputFormControl.enable();
    }
}
/** @nocollapse */ EuiDatepickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDatepickerComponent, deps: [{ token: i1.DateAdapter }, { token: i2.TranslateService }, { token: i3.LocaleService }, { token: i3.UxAppShellService }, { token: i0.ComponentFactoryResolver }, { token: i0.Injector }, { token: i0.ApplicationRef }, { token: i4.OverlayOutsideClickDispatcher }, { token: i0.ViewContainerRef }, { token: forwardRef(() => EuiLetterFormatDirective), optional: true }, { token: i5.NgControl, optional: true, self: true }, { token: MAT_DATE_FORMATS }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EuiDatepickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.0.3", type: EuiDatepickerComponent, selector: "eui-datepicker", inputs: { styleClass: "styleClass", value: "value", togglerIcon: "togglerIcon", togglerIconSvg: "togglerIconSvg", togglerLabel: "togglerLabel", placeholder: "placeholder", type: "type", startView: "startView", e2eAttr: "e2eAttr", minDate: "minDate", maxDate: "maxDate", datepickerFilter: "datepickerFilter", dateOutputFormat: "dateOutputFormat", customHeader: "customHeader", dateClass: "dateClass", isDatetimepicker: "isDatetimepicker", hasSeconds: "hasSeconds", isOneInputField: "isOneInputField", hasNoButton: "hasNoButton", isDatepickerBlock: "isDatepickerBlock", isReadOnly: "isReadOnly", isDisabled: "isDisabled", isInputDisabled: "isInputDisabled", isButtonDisabled: "isButtonDisabled", isPickerDisabled: "isPickerDisabled", isClearable: "isClearable", hasActionButtons: "hasActionButtons", hasTodayButton: "hasTodayButton", restrictToRegex: "restrictToRegex" }, outputs: { inputChange: "inputChange", dateSelect: "dateSelect" }, host: { properties: { "class": "this.cssClasses" } }, queries: [{ propertyName: "euiActionButtons", first: true, predicate: i0.forwardRef(function () { return EuiActionButtonsDirective; }), descendants: true }], viewQueries: [{ propertyName: "calendar", first: true, predicate: ["calendar"], descendants: true, static: true }, { propertyName: "templatePortalRef", first: true, predicate: ["templatePortalRef"], descendants: true }], usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"eui-datepicker__wrapper {{ styleClass }}\" [class.eui-datepicker__wrapper--responsive]=\"isDatepickerBlock\">\n    <div euiInputGroup>\n        <div class=\"eui-input-group-addon\">\n            <input\n                euiInputText\n                [readonly] =\"isReadOnly\"\n                [euiClearable]= \"isClearable\"\n                (clear)=\"onClear()\"\n                [class.eui-datepicker--no-button]=\"hasNoButton\"\n                [class.eui-datepicker--long-format]=\"!isDatepickerBlock && (isDatetimepicker || euiLetterFormat)\"\n                [class.eui-datepicker--block]=\"isDatepickerBlock\"\n                [formControl]=\"inputFormControl\"\n                [matDatepicker]=\"calendar\"\n                placeholder=\"{{ placeholder }}\"\n                (dateInput)=\"onDateInput($event)\"\n                (dateChange)=\"onDateChange($event)\"\n                [min]=\"minDate\"\n                [max]=\"maxDate\"\n                [matDatepickerFilter]=\"datepickerFilter\"\n                (click)=\"openCalendar()\"\n                autocomplete=\"off\"\n                aria-label=\"Date Input Field\"\n                (keypress)=\"onKeypress($event)\"\n                (change)=\"isDatetimepicker ? changedInput($event) : null\">\n            <mat-datepicker\n                #calendar\n                panelClass=\"mat-calendar-{{ type }}\"\n                [startView]=\"(type==='regular') ? (startView ? startView : convTypeToStartView(type)) : convTypeToStartView(type)\"\n                (yearSelected)=\"type === 'year' ? chosenDateHandler($event, calendar) : null\"\n                (monthSelected)=\"type === 'month' ? chosenDateHandler($event, calendar) : null\"\n                [touchUi]=\"breakpointsValue.isTablet || breakpointsValue.isMobile\"\n                [panelClass]=\"isDatetimepicker? 'eui-datepicker--container-height-large' : null\"\n                [disabled]=\"isPickerDisabled\"\n                [calendarHeaderComponent]=\"customHeader\"\n                [dateClass]=\"dateClass\"\n                (opened)=\"onOpened()\">\n            </mat-datepicker>\n            <button\n                *ngIf=\"!hasNoButton\"\n                (click)=\"openCalendar()\"\n                euiButton\n                type=\"button\"\n                euiSecondary\n                [euiIconButton] = \"!togglerLabel\"\n                [euiDisabled]=\"isButtonDisabled\"\n                aria-haspopup=\"dialog\">\n                <span *ngIf=\"!togglerLabel && togglerIcon\" euiIcon aria-label=\"Open Calendar\" iconClass=\"{{ togglerIcon }}\"></span>\n                <ng-container *ngIf=\"!togglerLabel && !togglerIcon\">\n                    <eui-icon-svg icon=\"{{ togglerIconSvg }}\" aria-label=\"Open Calendar\"></eui-icon-svg>\n                </ng-container>\n                <span *ngIf=\"togglerLabel\">{{ togglerLabel }}</span>\n            </button>\n        </div>\n    </div>\n</div>\n\n<ng-template #templatePortalRef>\n    <ng-content select=\"eui-action-buttons\"></ng-content>\n</ng-template>\n", styles: [".eui-datepicker .eui-datepicker__wrapper .eui-input-group{margin-bottom:0}.eui-datepicker .eui-datepicker__wrapper .eui-input-group-addon{width:unset}.eui-datepicker .eui-datepicker__wrapper input{border-bottom-right-radius:0;border-top-right-radius:0;width:calc(8.5 * var(--eui-base-spacing-m))}.eui-datepicker .eui-datepicker__wrapper input.eui-datepicker--long-format{width:calc(12.5 * var(--eui-base-spacing-m))}.eui-datepicker .eui-datepicker__wrapper input.eui-datepicker--block{width:100%}.eui-datepicker .eui-datepicker__wrapper input.eui-datepicker--no-button{border-bottom-right-radius:var(--eui-base-border-radius);border-top-right-radius:var(--eui-base-border-radius)}.eui-datepicker .eui-datepicker__wrapper--responsive .eui-input-group-addon{width:100%}.eui-datepicker--container-height-large{height:auto!important}.eui-datepicker__action-buttons{display:flex;justify-content:flex-end;align-items:center;padding:0 var(--eui-base-spacing-xs) var(--eui-base-spacing-xs) var(--eui-base-spacing-xs)}.eui-datepicker__actions-cancel-button{margin-right:var(--eui-base-spacing-m)}.mat-calendar.mat-calendar-year .mat-calendar-period-button{display:none}.mat-datepicker-dialog .mat-datepicker-content-touch{max-height:none}.mat-datepicker-content-touch .mat-datepicker-content-container{height:auto!important;max-height:-moz-fit-content!important;max-height:fit-content!important}.eui-datepicker--primary input{background-color:var(--eui-base-color-primary-10)}.eui-datepicker--secondary input{background-color:var(--eui-base-color-grey-10)}.eui-datepicker--info input{background-color:var(--eui-base-color-info-10)}.eui-datepicker--success input{background-color:var(--eui-base-color-success-10)}.eui-datepicker--warning input{background-color:var(--eui-base-color-warning-10)}.eui-datepicker--danger input{background-color:var(--eui-base-color-danger-10)}.eui-datepicker--accent input{background-color:var(--eui-base-color-accent-10)}\n"], dependencies: [{ kind: "directive", type: i6.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: i7.MatDatepicker, selector: "mat-datepicker", exportAs: ["matDatepicker"] }, { kind: "directive", type: i7.MatDatepickerInput, selector: "input[matDatepicker]", inputs: ["matDatepicker", "min", "max", "matDatepickerFilter"], exportAs: ["matDatepickerInput"] }, { kind: "component", type: i8.EuiButtonComponent, selector: "button[euiButton], a[euiButton]", inputs: ["e2eAttr", "id", "euiBasicButton", "euiButtonCall", "euiBlockButton", "isLoading", "euiIconButton", "euiLineWrap"], outputs: ["buttonClick"] }, { kind: "component", type: i9.EuiIconComponent, selector: "div[euiIcon], span[euiIcon], i[euiIcon], eui-icon", inputs: ["aria-label", "iconClass", "isLoading"] }, { kind: "component", type: i9.EuiIconSvgComponent, selector: "eui-icon-svg, span[euiIconSvg], i[euiIconSvg]", inputs: ["icon", "size", "fillColor", "set", "ariaLabelledby", "role", "style", "iconUrl", "aria-label", "ariaHidden", "focusable", "isLoading"] }, { kind: "component", type: i10.EuiInputTextComponent, selector: "input[euiInputText]", inputs: ["class", "isInvalid"] }, { kind: "component", type: i11.EuiInputGroupComponent, selector: "div[euiInputGroup]", inputs: ["styleClass"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDatepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'eui-datepicker', encapsulation: ViewEncapsulation.None, template: "<div class=\"eui-datepicker__wrapper {{ styleClass }}\" [class.eui-datepicker__wrapper--responsive]=\"isDatepickerBlock\">\n    <div euiInputGroup>\n        <div class=\"eui-input-group-addon\">\n            <input\n                euiInputText\n                [readonly] =\"isReadOnly\"\n                [euiClearable]= \"isClearable\"\n                (clear)=\"onClear()\"\n                [class.eui-datepicker--no-button]=\"hasNoButton\"\n                [class.eui-datepicker--long-format]=\"!isDatepickerBlock && (isDatetimepicker || euiLetterFormat)\"\n                [class.eui-datepicker--block]=\"isDatepickerBlock\"\n                [formControl]=\"inputFormControl\"\n                [matDatepicker]=\"calendar\"\n                placeholder=\"{{ placeholder }}\"\n                (dateInput)=\"onDateInput($event)\"\n                (dateChange)=\"onDateChange($event)\"\n                [min]=\"minDate\"\n                [max]=\"maxDate\"\n                [matDatepickerFilter]=\"datepickerFilter\"\n                (click)=\"openCalendar()\"\n                autocomplete=\"off\"\n                aria-label=\"Date Input Field\"\n                (keypress)=\"onKeypress($event)\"\n                (change)=\"isDatetimepicker ? changedInput($event) : null\">\n            <mat-datepicker\n                #calendar\n                panelClass=\"mat-calendar-{{ type }}\"\n                [startView]=\"(type==='regular') ? (startView ? startView : convTypeToStartView(type)) : convTypeToStartView(type)\"\n                (yearSelected)=\"type === 'year' ? chosenDateHandler($event, calendar) : null\"\n                (monthSelected)=\"type === 'month' ? chosenDateHandler($event, calendar) : null\"\n                [touchUi]=\"breakpointsValue.isTablet || breakpointsValue.isMobile\"\n                [panelClass]=\"isDatetimepicker? 'eui-datepicker--container-height-large' : null\"\n                [disabled]=\"isPickerDisabled\"\n                [calendarHeaderComponent]=\"customHeader\"\n                [dateClass]=\"dateClass\"\n                (opened)=\"onOpened()\">\n            </mat-datepicker>\n            <button\n                *ngIf=\"!hasNoButton\"\n                (click)=\"openCalendar()\"\n                euiButton\n                type=\"button\"\n                euiSecondary\n                [euiIconButton] = \"!togglerLabel\"\n                [euiDisabled]=\"isButtonDisabled\"\n                aria-haspopup=\"dialog\">\n                <span *ngIf=\"!togglerLabel && togglerIcon\" euiIcon aria-label=\"Open Calendar\" iconClass=\"{{ togglerIcon }}\"></span>\n                <ng-container *ngIf=\"!togglerLabel && !togglerIcon\">\n                    <eui-icon-svg icon=\"{{ togglerIconSvg }}\" aria-label=\"Open Calendar\"></eui-icon-svg>\n                </ng-container>\n                <span *ngIf=\"togglerLabel\">{{ togglerLabel }}</span>\n            </button>\n        </div>\n    </div>\n</div>\n\n<ng-template #templatePortalRef>\n    <ng-content select=\"eui-action-buttons\"></ng-content>\n</ng-template>\n", styles: [".eui-datepicker .eui-datepicker__wrapper .eui-input-group{margin-bottom:0}.eui-datepicker .eui-datepicker__wrapper .eui-input-group-addon{width:unset}.eui-datepicker .eui-datepicker__wrapper input{border-bottom-right-radius:0;border-top-right-radius:0;width:calc(8.5 * var(--eui-base-spacing-m))}.eui-datepicker .eui-datepicker__wrapper input.eui-datepicker--long-format{width:calc(12.5 * var(--eui-base-spacing-m))}.eui-datepicker .eui-datepicker__wrapper input.eui-datepicker--block{width:100%}.eui-datepicker .eui-datepicker__wrapper input.eui-datepicker--no-button{border-bottom-right-radius:var(--eui-base-border-radius);border-top-right-radius:var(--eui-base-border-radius)}.eui-datepicker .eui-datepicker__wrapper--responsive .eui-input-group-addon{width:100%}.eui-datepicker--container-height-large{height:auto!important}.eui-datepicker__action-buttons{display:flex;justify-content:flex-end;align-items:center;padding:0 var(--eui-base-spacing-xs) var(--eui-base-spacing-xs) var(--eui-base-spacing-xs)}.eui-datepicker__actions-cancel-button{margin-right:var(--eui-base-spacing-m)}.mat-calendar.mat-calendar-year .mat-calendar-period-button{display:none}.mat-datepicker-dialog .mat-datepicker-content-touch{max-height:none}.mat-datepicker-content-touch .mat-datepicker-content-container{height:auto!important;max-height:-moz-fit-content!important;max-height:fit-content!important}.eui-datepicker--primary input{background-color:var(--eui-base-color-primary-10)}.eui-datepicker--secondary input{background-color:var(--eui-base-color-grey-10)}.eui-datepicker--info input{background-color:var(--eui-base-color-info-10)}.eui-datepicker--success input{background-color:var(--eui-base-color-success-10)}.eui-datepicker--warning input{background-color:var(--eui-base-color-warning-10)}.eui-datepicker--danger input{background-color:var(--eui-base-color-danger-10)}.eui-datepicker--accent input{background-color:var(--eui-base-color-accent-10)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.DateAdapter }, { type: i2.TranslateService }, { type: i3.LocaleService }, { type: i3.UxAppShellService }, { type: i0.ComponentFactoryResolver }, { type: i0.Injector }, { type: i0.ApplicationRef }, { type: i4.OverlayOutsideClickDispatcher }, { type: i0.ViewContainerRef }, { type: EuiLetterFormatDirective, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [forwardRef(() => EuiLetterFormatDirective)]
                }] }, { type: i5.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_DATE_FORMATS]
                }] }]; }, propDecorators: { calendar: [{
                type: ViewChild,
                args: ['calendar', { static: true }]
            }], templatePortalRef: [{
                type: ViewChild,
                args: ['templatePortalRef']
            }], euiActionButtons: [{
                type: ContentChild,
                args: [forwardRef(() => EuiActionButtonsDirective)]
            }], inputChange: [{
                type: Output
            }], dateSelect: [{
                type: Output
            }], styleClass: [{
                type: Input
            }], value: [{
                type: Input
            }], togglerIcon: [{
                type: Input
            }], togglerIconSvg: [{
                type: Input
            }], togglerLabel: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], type: [{
                type: Input
            }], startView: [{
                type: Input
            }], e2eAttr: [{
                type: Input
            }], minDate: [{
                type: Input
            }], maxDate: [{
                type: Input
            }], datepickerFilter: [{
                type: Input
            }], dateOutputFormat: [{
                type: Input
            }], customHeader: [{
                type: Input
            }], dateClass: [{
                type: Input
            }], isDatetimepicker: [{
                type: Input
            }], hasSeconds: [{
                type: Input
            }], isOneInputField: [{
                type: Input
            }], hasNoButton: [{
                type: Input
            }], isDatepickerBlock: [{
                type: Input
            }], isReadOnly: [{
                type: Input
            }], isDisabled: [{
                type: Input
            }], isInputDisabled: [{
                type: Input
            }], isButtonDisabled: [{
                type: Input
            }], isPickerDisabled: [{
                type: Input
            }], isClearable: [{
                type: Input
            }], hasActionButtons: [{
                type: Input
            }], hasTodayButton: [{
                type: Input
            }], restrictToRegex: [{
                type: Input
            }], cssClasses: [{
                type: HostBinding,
                args: ['class']
            }] } });
const LETTER_FORMAT = {
    parse: {
        dateInput: 'LL',
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'LL',
    },
};
const YEAR_FORMAT = {
    parse: {
        dateInput: 'YYYY',
    },
    display: {
        dateInput: 'YYYY',
        monthYearLabel: 'YYYY',
        dateA11yLabel: 'YYYY',
        monthYearA11yLabel: 'YYYY',
    },
};
const MONTH_YEAR_FORMAT = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MM/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};
class EuiLetterFormatDirective {
}
/** @nocollapse */ EuiLetterFormatDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiLetterFormatDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ EuiLetterFormatDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: EuiLetterFormatDirective, selector: "[euiLetterFormat]", providers: [
        { provide: MAT_DATE_FORMATS, useValue: LETTER_FORMAT },
    ], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiLetterFormatDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[euiLetterFormat]',
                    providers: [
                        { provide: MAT_DATE_FORMATS, useValue: LETTER_FORMAT },
                    ],
                }]
        }] });
class EuiYearFormatDirective {
}
/** @nocollapse */ EuiYearFormatDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiYearFormatDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ EuiYearFormatDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: EuiYearFormatDirective, selector: "[euiYearFormat]", providers: [
        { provide: MAT_DATE_FORMATS, useValue: YEAR_FORMAT },
    ], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiYearFormatDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[euiYearFormat]',
                    providers: [
                        { provide: MAT_DATE_FORMATS, useValue: YEAR_FORMAT },
                    ],
                }]
        }] });
class EuiMonthYearFormatDirective {
}
/** @nocollapse */ EuiMonthYearFormatDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiMonthYearFormatDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ EuiMonthYearFormatDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: EuiMonthYearFormatDirective, selector: "[euiMonthYearFormat]", providers: [
        { provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMAT },
    ], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiMonthYearFormatDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[euiMonthYearFormat]',
                    providers: [
                        { provide: MAT_DATE_FORMATS, useValue: MONTH_YEAR_FORMAT },
                    ],
                }]
        }] });
/* eslint-disable */
class EuiActionButtonsDirective {
    constructor() {
        this.class = 'eui-datepicker__action-buttons';
    }
}
/** @nocollapse */ EuiActionButtonsDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiActionButtonsDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
/** @nocollapse */ EuiActionButtonsDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.0.3", type: EuiActionButtonsDirective, selector: "eui-action-buttons", host: { properties: { "class": "this.class" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiActionButtonsDirective, decorators: [{
            type: Directive,
            args: [{ selector: 'eui-action-buttons' }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }] } });

const DEFAULT_FORMATS = {
    parse: {
        dateInput: 'DD/MM/YYYY',
    },
    display: {
        dateInput: 'DD/MM/YYYY',
        monthYearLabel: 'MM/YYYY',
        dateA11yLabel: 'Date/Month/Year',
        monthYearA11yLabel: 'Month/Year',
    },
};
class EuiDatepickerModule {
}
/** @nocollapse */ EuiDatepickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDatepickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EuiDatepickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.0.3", ngImport: i0, type: EuiDatepickerModule, declarations: [EuiDatepickerComponent,
        EuiLetterFormatDirective,
        EuiYearFormatDirective,
        EuiMonthYearFormatDirective,
        EuiActionButtonsDirective], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        TranslateModule,
        MatMomentDateModule,
        EuiButtonModule,
        EuiIconModule,
        EuiTimepickerModule,
        EuiInputTextModule,
        EuiInputGroupModule], exports: [EuiDatepickerComponent,
        EuiLetterFormatDirective,
        EuiYearFormatDirective,
        EuiMonthYearFormatDirective,
        EuiActionButtonsDirective] });
/** @nocollapse */ EuiDatepickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDatepickerModule, providers: [
        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: DEFAULT_FORMATS },
    ], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MatDatepickerModule,
        TranslateModule,
        MatMomentDateModule,
        EuiButtonModule,
        EuiIconModule,
        EuiTimepickerModule,
        EuiInputTextModule,
        EuiInputGroupModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.0.3", ngImport: i0, type: EuiDatepickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        MatDatepickerModule,
                        TranslateModule,
                        MatMomentDateModule,
                        EuiButtonModule,
                        EuiIconModule,
                        EuiTimepickerModule,
                        EuiInputTextModule,
                        EuiInputGroupModule
                    ],
                    exports: [
                        EuiDatepickerComponent,
                        EuiLetterFormatDirective,
                        EuiYearFormatDirective,
                        EuiMonthYearFormatDirective,
                        EuiActionButtonsDirective
                    ],
                    declarations: [
                        EuiDatepickerComponent,
                        EuiLetterFormatDirective,
                        EuiYearFormatDirective,
                        EuiMonthYearFormatDirective,
                        EuiActionButtonsDirective
                    ],
                    entryComponents: [EuiTimepickerComponent],
                    providers: [
                        { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
                        { provide: MAT_DATE_FORMATS, useValue: DEFAULT_FORMATS },
                    ]
                }]
        }] });

/**
 * @description
 * Validator that validates the date based on the provided format.
 *
 * @usageNotes
 * If the user types a value in the input field that is not aligned with the provided format the component propagates a null value that
 * can be used to validate the input field.
 *
 * @returns An error map with the
 * `invalidDate` if the validation check fails, otherwise `null`.
 */
const dateInputValidator = (control) => {
    return control.value === null ? { 'invalidDate': true } : null;
};

/**
 * Generated bundle index. Do not edit.
 */

export { DEFAULT_FORMATS, EuiActionButtonsDirective, EuiDatepickerComponent, EuiDatepickerModule, EuiLetterFormatDirective, EuiMonthYearFormatDirective, EuiYearFormatDirective, LETTER_FORMAT, MONTH_YEAR_FORMAT, YEAR_FORMAT, dateInputValidator };
